import type { org } from "boislocal-platform-platform-api-api-js-export";

// Commands
export type CsvImportUploadCommand = org.boislocal.platform.f2.csvimport.domain.command.CsvImportUploadCommandDTO;
export type CsvImportUploadResult = org.boislocal.platform.f2.csvimport.domain.command.CsvImportUploadResultDTO;
export type CsvImportConfirmCommand = org.boislocal.platform.f2.csvimport.domain.command.CsvImportConfirmCommandDTO;
export type CsvImportConfirmResult = org.boislocal.platform.f2.csvimport.domain.command.CsvImportConfirmResultDTO;
export type CsvImportCancelCommand = org.boislocal.platform.f2.csvimport.domain.command.CsvImportCancelCommandDTO;
export type CsvImportCancelResult = org.boislocal.platform.f2.csvimport.domain.command.CsvImportCancelResultDTO;
export type CsvImportRowEdit = org.boislocal.platform.f2.csvimport.domain.command.CsvImportRowEditDTO;

// Queries
export type CsvImportStatusQuery = org.boislocal.platform.f2.csvimport.domain.query.CsvImportStatusQueryDTO;
export type CsvImportStatusResult = org.boislocal.platform.f2.csvimport.domain.query.CsvImportStatusResultDTO;

// Models
export type CompanyInfo = org.boislocal.platform.f2.csvimport.domain.model.CompanyInfoDTO;
export type CsvImportRow = org.boislocal.platform.f2.csvimport.domain.model.CsvImportRowDTO;
export type CsvImportError = org.boislocal.platform.f2.csvimport.domain.model.CsvImportErrorDTO;
export type CsvImportResultRow = org.boislocal.platform.f2.csvimport.domain.model.CsvImportResultRowDTO;
export type CsvImportStats = org.boislocal.platform.f2.csvimport.domain.model.CsvImportStatsDTO;
export type DuplicateInfo = org.boislocal.platform.f2.csvimport.domain.model.DuplicateInfoDTO;

// Enums
const makeEnum = <T extends string>(values: readonly T[]): { readonly [K in T]: K } & { valueOf(name: string): T } => {
  const obj = {} as Record<string, string> & { valueOf(name: string): T };
  for (const v of values) obj[v] = v;
  obj.valueOf = (name: string) => name as T;
  return obj as { readonly [K in T]: K } & { valueOf(name: string): T };
};

export const CsvImportStatus = makeEnum(["PENDING", "PARSING", "VALIDATING", "PREVIEW", "CONFIRMED", "IMPORTING", "COMPLETED", "PARSE_ERROR", "VALIDATION_ERROR", "CANCELLED", "IMPORT_ERROR"] as const);
export type CsvImportStatusType = org.boislocal.platform.f2.csvimport.domain.model.CsvImportStatus;
export const CsvRowStatus = makeEnum(["VALID", "INVALID", "DUPLICATE", "WARNING"] as const);
export type CsvRowStatusType = org.boislocal.platform.f2.csvimport.domain.model.CsvRowStatus;
export const DuplicateAction = makeEnum(["CREATE_NEW", "UPDATE_EXISTING", "SKIP"] as const);
export type DuplicateActionType = org.boislocal.platform.f2.csvimport.domain.model.DuplicateAction;
export const DuplicateMatchType = makeEnum(["EXACT_ID", "NAME_LOCATION", "COORDINATES"] as const);
export type DuplicateMatchTypeValue = org.boislocal.platform.f2.csvimport.domain.model.DuplicateMatchType;
export const ImportRowAction = makeEnum(["CREATED", "UPDATED", "SKIPPED", "FAILED"] as const);
export type ImportRowActionType = org.boislocal.platform.f2.csvimport.domain.model.ImportRowAction;
